import { User } from '../home/interfaces/user.interface';

export const isUserVerified = (user: User): boolean => {
  const { apple_id, email_confirmed, fb_id, phone_number_confirmed } = user;
  return !!apple_id || email_confirmed || !!fb_id || phone_number_confirmed;
};
